import { render, staticRenderFns } from "./SentRegisterSuccess.vue?vue&type=template&id=65e3f4a0&scoped=true&"
import script from "./SentRegisterSuccess.vue?vue&type=script&lang=ts&"
export * from "./SentRegisterSuccess.vue?vue&type=script&lang=ts&"
import style0 from "./SentRegisterSuccess.vue?vue&type=style&index=0&id=65e3f4a0&prod&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65e3f4a0",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
installComponents(component, {VBtn})
